  <template>
  <div class="rent" :class="{ isCenters: returnCenters }">
    <SiteNav></SiteNav>
    <div class="rent--map-space-wrap">
      <div class="rent--map-wrap rent--map" :class="toggleMap ? 'is--toggled' : ''">
        <div class="toggle-pane__header">
          <div class="toggle-pane__header-title">Spaces</div>
          <a href="#" @click.prevent="closeMobileToggle()" class="toggle-pane__header-close">
            <img src="/assets/icon_close.svg" alt="Close">
          </a>
        </div>
        <div class="toggle-pane__content">
          <Map :data="listings.edges" :returnCenters="returnCenters" :key="componentKey"></Map>
        </div>
      </div>

      <div class="rent--spaces-wrap" :class="toggleMap === 'listings' ? 'is--toggled' : ''">
        <div v-if="alertMessage" class="alert alert-warning">{{ alertMessage }}</div>
        <SpacesList :data="listings.edges" :columns="2" :returnCenters="returnCenters" :showCart="showCart" :isLoading="isLoading"></SpacesList>
      </div>
    </div>

    <div class="rent--filters" :class="toggleFilters ? 'is--toggled' : ''">
        <div class="toggle-pane__header">
          <div class="toggle-pane__header-title">Filters</div>
          <a href="#" @click.prevent="closeMobileToggle()" class="toggle-pane__header-close">
            <img src="/assets/icon_close.svg" alt="Close">
          </a>
        </div>
        <div class="toggle-pane__content">
          <FilterBar :returnCenters="returnCenters"></FilterBar>
        </div>
    </div>

    <div class="toggle-menu">
      <button @click.prevent="toggleMobileFilters()" class="toggle-menu__button" :class="toggleFilters ? 'is--active' : ''">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.6 16.2C12.7974 16.2 16.2 12.7974 16.2 8.6C16.2 4.40263 12.7974 1 8.6 1C4.40263 1 1 4.40263 1 8.6C1 12.7974 4.40263 16.2 8.6 16.2Z" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M17.0004 17L15.4004 15.4" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        {{$store.getters.language.filters}}
        </span>
      </button>
      <button @click.prevent="toggleMobileMap()" class="toggle-menu__button" :class="toggleMap === 'map' ? 'is--active' : ''">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" stroke="#4D4D4D"/>
        <path d="M3 15.5L9.25 9M15.5 2.5L9.25 9M9.25 9L14.5 14" stroke="#4D4D4D"/>
        <path d="M3.80394 4.03527L3.96356 3.84373C4.76315 2.88422 6.23685 2.88422 7.03644 3.84373L7.19605 4.03527C7.68759 4.6251 7.79806 5.44426 7.48034 6.14324L6.41037 8.49719C6.0551 9.27879 4.9449 9.27879 4.58963 8.49719L3.51965 6.14324C3.20194 5.44426 3.31241 4.6251 3.80394 4.03527Z" stroke="#4D4D4D"/>
        <circle cx="5.5" cy="5.5" r="0.5" fill="#4D4D4D"/>
        </svg>
        {{$store.getters.language.map}}
      </button>
    </div>

    <div @click.prevent="closeMobileToggle()" class="rent-filters-bg" :class="toggleFilters || toggleMap ? 'is--toggled' : ''"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import SiteNav from "../../components/global/SiteNav"
import Map from "../../components/search/Map"
import SpacesList from "../../components/search/SpacesList"
import DatePicker from "../../components/search/DatePicker"
import FilterBar from "../../components/search/FilterBar"

import gql from 'graphql-tag'

export default {
  name: 'Rent',
  data: () => ({
    listings: [],
    searchResults: [],
    returnCenters: true,
    componentKey: 0,
    isLoading: true,
    showCart: false,
    showModal: false,
    toggleMap: false,
    toggleFilters: false,
    alertMessage: ''
  }),
  components: {
    SiteNav,
    Map,
    SpacesList,
    DatePicker,
    FilterBar
  },
  watch: {
    // Watch for state changes
    '$store.state.rent': {
      handler (state) {
        this.listingGroupsQuery()
        this.urlState()
      },
      deep: true
    }
  },
  created () {
    this.alertMessage = this.$route.query.message || ''
  },
  mounted () {
    this.getUser()
  },
  methods: {
    async getUser () {
      var self = this
      const response = await this.$apollo.query({
        query: gql`
        query getUser {
          getUser {
              id
          }
        }
        `,
        variables: {}
      }).then((response) => {
        if(response.data.getUser){
            self.showCart = true;
            self.getBookings() // not sure if this is the correct response
        }
      })
    },
    async getBookings () {
      const response = await this.$apollo.query({
        query: gql`
        query getBookings {
          cartBookings {
            edges {
              node {
                id
                fromDate
                toDate
                listing{
                  id
                  title
                  price
                }
              }
            }
          }
        }
        `
      }).then((response) => {
          console.log(response)
      })
    },
    async createBooking (listingId, price) {
      const response = await this.$apollo.mutate({
        mutation: gql`
        mutation createBooking ($listingId: Float!, $fromDate: String!, $toDate: String!, $price: Float!) {
          createBooking(input: { listingId: $listingId, fromDate: $fromDate, toDate: $toDate, price: $price }) {
            id
          }
        }
        `,
        variables: {
          listingId: listingId,
          fromDate: self.$store.state.rent.from_date,
          toDate: self.$store.state.rent.to_date,
          price: price
        }
      }).then((response) => {
        console.log(response)
      })
    },
    async deleteBooking (id) {
      const response = await this.$apollo.mutate({
        mutation: gql`
        mutation deleteBooking ($id: Float!) {
          deleteBooking(input: { bookingId: $id }) {
            id
          }
        }
        `,
        variables: {
          id: id
        }
      }).then((response) => {
        console.log(response)
      })
    },
    async listingGroupsQuery () {
      this.isLoading = true
      var self = this
      const response = await this.$apollo.query({
        query: gql`
        query getListingGroups ($latitude: Float, $longitude: Float, $latitude2: Float, $longitude2: Float, $amenityIds: [Int!], $featureIds: [String!], $category: [String!], $fromDate: String, $toDate: String, $priceFrom: Int, $priceTo: Int, $capacityFrom: Int, $capacityTo: Int) {
          listingGroups(latitude: $latitude, longitude: $longitude, latitude2: $latitude2, longitude2: $longitude2, amenityIds: $amenityIds, featureIds: $featureIds, category: $category, fromDate: $fromDate, toDate: $toDate, priceFrom: $priceFrom, priceTo: $priceTo, capacityFrom: $capacityFrom, capacityTo: $capacityTo) {
            edges {
              node {
                id
                name
                slug
                title
                city
                subtitle
                description
                hexColour
                isShoppingCentre
                address
                featuredDescription
                featuredImageUrl
                iframeEmbed
                featuredLogoUrl
                featuredImage2Url
                featuredImage3Url
                weight
                latitude
                longitude
                houseRules
                insuranceAndSafety
                additionalNotes
                cancellationPolicy
                footfall
                mapClusterLogoUrl
                createdAt
                updatedAt
                listings {
                  edges {
                    node {
                      id
                    }
                  }
                }
              }
            }
          }
        }`,
        variables: {
          latitude: self.$store.state.rent.bounds.latitude,
          longitude: self.$store.state.rent.bounds.longitude,
          latitude2: self.$store.state.rent.bounds.latitude2,
          longitude2: self.$store.state.rent.bounds.longitude2,
          category: self.$store.state.rent.category_id,
          fromDate: self.$store.state.rent.from_date,
          toDate: self.$store.state.rent.to_date,
          amenityIds: self.$store.state.rent.amenity_id,
          featureIds: self.$store.state.rent.feature_id,
          priceFrom: self.$store.state.rent.from_price,
          priceTo: self.$store.state.rent.to_price,
          capacityFrom: self.$store.state.rent.from_footfall,
          capacityTo: self.$store.state.rent.to_footfall
        }
      }).then((response) => {
        self.listings = response.data.listingGroups
        this.isLoading = false
      }).catch((error) => {
        console.log(error)
        self.$router.push({ name: 'PageNotFound' })
      })
    },
    closeMobileToggle () {
      this.toggleMap = false
      this.toggleFilters = false
    },
    toggleMobileMap (active) {
      this.toggleMap = !this.toggleMap
    },
    toggleMobileFilters () {
      this.toggleFilters = !this.toggleFilters
    },
    handleModal () {
      var self = this
      if(!is_session){
      setTimeout(function () {
        self.showModal = true
      }, 30000);
      }
    },
    populateFromQuery () {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
        var rent = {
          category_id: urlParams.get('category_id') ? urlParams.get('category_id').split(',').map(element => { return String(element) }) : [],
          amenity_id: urlParams.get('amenity_id') ? urlParams.get('amenity_id').split(',').map(element => { return Number(element) }) : [],
          feature_id: urlParams.get('feature_id') ? urlParams.get('feature_id').split(',').map(element => { return String(element) }) : [],
          from_date: urlParams.get('from_date') ? urlParams.get('from_date') : null,
          to_date: urlParams.get('to_date') ? urlParams.get('to_date') : null,
          from_price: urlParams.get('from_price') ? Number(urlParams.get('from_price')) : null,
          to_price: urlParams.get('to_price') ? Number(urlParams.get('to_price')) : null,
          from_footfall: urlParams.get('from_footfall') ? Number(urlParams.get('from_footfall')) : null,
          to_footfall: urlParams.get('to_footfall') ? Number(urlParams.get('to_footfall')) : null
        }
        this.$store.commit('replace', rent)
    },
    urlState () {
      var params = this.$store.state.rent
      var queryUrl = window.location.href.split('?')[0]
      var queryParam = Object.keys(params).filter(function (key) {
        if (Array.isArray(params[key]) === true && params[key].length > 0) {
          return key
        } else if (Array.isArray(params[key]) === false && params[key] !== '' && params[key] !== null && key !== 'distance' && key !== 'bounds' && key !== 'translations') {
          return key
        } else {
          return false
        }
      }).map(function (key) {
        return encodeURIComponent(key) + '=' + params[key]
      }).join('&')
      if (window.location.search !== '?' + queryParam) {
        if (queryParam !== '') {
          history.replaceState(queryUrl, null, '?' + queryParam)
        } else {
          history.replaceState(queryUrl, null, queryUrl)
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../scss/global/includes";

.rent--map-space-wrap {
  width: 100%;
  padding-top: 0;
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  bottom: 0;
  @include breakpoint(tablet-landscape) {
    position: relative;
  }
}

.rent--map-space-wrap  .toggle-pane__content {
  @include breakpoint(tablet-landscape) {
    top: 0px!important;
    position: relative!important;
    height: 100%;
  }
}

.rent--map {

  &.is--toggled {
    @include breakpoint(tablet-landscape) {
      pointer-events: auto;
      visibility: visible;
      @include transform(translate(0, 0));
    }
  }

  @include breakpoint(tablet-landscape) {
    position: fixed;
    pointer-events: none;
    visibility: hidden;
    left: 0;
    right: 0;
    z-index: 100009;
    width: 100%;
    bottom: 0px;
    border-radius: 4px 4px 0 0;
    height: calc(100vh - 60px);
    height: calc(100svh - 60px);
    top: auto;
    background: $light-grey;
    @include ease;
    @include transform(translate(0, 100%));
  }
}

.rent--filters {

  &.is--toggled {
    @include breakpoint(tablet-landscape) {
      pointer-events: auto;
      visibility: visible;
      @include transform(translate(0, 0));
    }
  }

  @include breakpoint(tablet-landscape) {
    position: fixed;
    pointer-events: none;
    visibility: hidden;
    left: 0;
    right: 0;
    z-index: 100009;
    width: 100%;
    bottom: 0px;
    border-radius: 4px 4px 0 0;
    height: calc(100vh - 60px);
    height: calc(100svh - 60px);
    background: $light-grey;
    top: auto;
    @include ease;
    @include transform(translate(0, 100%));
  }
}

.rent--spaces-wrap {
  position: absolute;
  top: 0;
  left: 230px;
  bottom: 0;
  width: calc(55% - (230px / 2));
  overflow: hidden;
  @include breakpoint(tablet-landscape) {
    width: 100%;
    left: 0px;
    position: relative;
    overflow: visible;
  }
  .rent--spaces {
    @include breakpoint(tablet-landscape) {
      position: relative;
    }
  }
  .rent--spaces-scroll {
    @include breakpoint(tablet-landscape) {
      position: relative;
      padding: 16px;
      padding-bottom: 116px;
    }
  }
  .rent--spaces-bg {
      @include breakpoint(tablet-landscape) {
        background: #FFFFFF;
        pointer-events: auto;
        border-radius: 0;
        padding-top: 0px;
      }
  }
}
.rent--map-wrap {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: calc(45% - (230px / 2));
  overflow: hidden;
  @include breakpoint(tablet-landscape) {
    width: 100%;
    top: 60px;
    position: fixed;

    .map-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
    }

    .toggle-pane__header {
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(2px);
    }

    .toggle-pane__content {
      padding: 0px;
      margin-top: -64px;
    }
  }
}
.rent--toggle-spaces {
  position: fixed;
  bottom: 30px;
  left: 30px;
  z-index: 1004;
  background: #FFFFFF;
  border-radius: 10px;
  color: $primary;
  font-family: $font-bold;
  padding: 15px 30px;
  box-shadow: rgba(0,0,0, 0.6) 0 6px 20px;
  transition: all 0.3s ease-in-out;
  &.is--active {
    background: $primary;
    color: #FFFFFF;
  }
}

.rent-filters-bg {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  @include ease;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10009;
  background: rgba(#000000, 0.3);
  @include breakpoint(tablet-landscape) {
    &.is--toggled {
      opacity: 1;
      pointer-events: auto;
      visibility: visible;
    }
  }
}
</style>
